(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gad-before-after"] && !Shopify.designMode) return;
  try {
    
  class GadBeforeAfter extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.range = this.querySelector('.gad-ba__range');
      this.range.addEventListener('input', () => this.set(parseFloat(this.range.value)));
      this.addEventListener('pointerdown', (e) => this.down(e));
      this.elastic = this.classList.contains('gad-ba--elastic') && !(window.Gadsden && Gadsden.reduceMotion());
      if (this.elastic) this.setupElastic();
    }

    set(pct, yFrac) {
      const v = Math.max(0, Math.min(100, pct));
      this.style.setProperty('--pos', `${v}%`);
      this.range.value = Math.round(v);
      if (this.elastic) {
        this.target = v;
        if (yFrac != null) this.hy = Math.max(0.1, Math.min(0.9, yFrac));
        this.style.setProperty('--hy', `${this.hy * 100}%`);
        this.kick();
      }
    }

    fromEvent(e) {
      const r = this.getBoundingClientRect();
      this.lastY = (e.clientY - r.top) / r.height;
      return ((e.clientX - r.left) / r.width) * 100;
    }

    /* Línea elástica: los extremos de la línea siguen a la manija con un resorte. */
    setupElastic() {
      this.classList.add('is-elastic');
      this.after = this.querySelector('.gad-ba__img--after');
      this.curve = this.querySelector('.gad-ba__curve path');
      const start = parseFloat(this.dataset.start) || 50;
      this.target = start;
      this.hy = 0.5;
      this.ends = { top: start, bot: start, vt: 0, vb: 0 };
      this.draw();
      new ResizeObserver(() => this.draw()).observe(this);
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        setTimeout(() => this.set(start + 14), 150);
        setTimeout(() => this.set(start), 650);
      }, { threshold: 0.5 });
      io.observe(this);
    }

    kick() {
      if (this.raf) return;
      let last = performance.now();
      const step = (now) => {
        const dt = Math.min(0.032, (now - last) / 1000);
        last = now;
        const e = this.ends;
        const k = 620;
        const c = 44;
        e.vt += (k * (this.target - e.top) - c * e.vt) * dt;
        e.vb += (k * (this.target - e.bot) - c * e.vb) * dt;
        e.top += e.vt * dt;
        e.bot += e.vb * dt;
        this.draw();
        const still = Math.abs(this.target - e.top) < 0.05 && Math.abs(this.target - e.bot) < 0.05 && Math.abs(e.vt) < 0.5 && Math.abs(e.vb) < 0.5;
        if (still) {
          e.top = e.bot = this.target;
          e.vt = e.vb = 0;
          this.draw();
          this.raf = 0;
          return;
        }
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }

    draw() {
      const W = this.clientWidth;
      const H = this.clientHeight;
      if (!W || !H) return;
      const xt = (this.ends.top / 100) * W;
      const xb = (this.ends.bot / 100) * W;
      const xh = (this.target / 100) * W;
      const yh = this.hy * H;
      const t = this.hy;
      const cx = (xh - (1 - t) * (1 - t) * xt - t * t * xb) / (2 * t * (1 - t));
      const cy = (yh - t * t * H) / (2 * t * (1 - t));
      const d = `M ${xt.toFixed(1)} 0 Q ${cx.toFixed(1)} ${cy.toFixed(1)} ${xb.toFixed(1)} ${H}`;
      this.curve.setAttribute('d', d);
      this.after.style.clipPath = `path('${d} L ${W} ${H} L ${W} 0 Z')`;
    }

    down(e) {
      if (e.button > 0) return;
      const start = { x: e.clientX, y: e.clientY, decided: e.pointerType === 'mouse' };
      if (start.decided) this.set(this.fromEvent(e), this.lastY);
      this.classList.add('is-dragging');
      const move = (ev) => {
        if (!start.decided) {
          const dx = Math.abs(ev.clientX - start.x);
          const dy = Math.abs(ev.clientY - start.y);
          if (dx < 6 && dy < 6) return;
          start.decided = true;
          if (dy > dx) return end();
        }
        ev.preventDefault();
        this.set(this.fromEvent(ev), this.lastY);
      };
      const end = () => {
        this.classList.remove('is-dragging');
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
      };
      window.addEventListener('pointermove', move, { passive: false });
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }
  }

  if (!customElements.get('gad-before-after')) customElements.define('gad-before-after', GadBeforeAfter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-hero-slides"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gad-hero__sound');
    if (!btn) return;
    const videos = btn.closest('.gad-hero__slide').querySelectorAll('video');
    const unmute = btn.getAttribute('aria-pressed') !== 'true';
    videos.forEach((v) => {
      v.muted = !unmute;
      if (unmute && v.offsetParent !== null && v.paused) v.play().catch(() => {});
    });
    btn.setAttribute('aria-pressed', String(unmute));
    btn.setAttribute('aria-label', unmute ? btn.dataset.labelMute : btn.dataset.labelUnmute);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-hotspots"] && !Shopify.designMode) return;
  try {
    
  class GadHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const el = e.target.closest('[data-gad-hs]');
        if (el) this.select(el.dataset.gadHs, el.classList.contains('gad-hs__point'));
      });
      this.addEventListener('shopify:block:select', (e) => {
        const li = e.target.closest('[data-gad-hs]');
        if (li) this.select(li.dataset.gadHs, false);
      });
    }

    select(n, fromPoint) {
      this.querySelectorAll('[data-gad-hs]').forEach((el) => el.classList.toggle('is-active', el.dataset.gadHs === n));
      const li = this.querySelector(`.gad-hs__item[data-gad-hs="${n}"]`);
      if (fromPoint && li && li.getBoundingClientRect().top > window.innerHeight) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  if (!customElements.get('gad-hotspots')) customElements.define('gad-hotspots', GadHotspots);

  class GadHotspotsFull extends HTMLElement {
    connectedCallback() {
      this.veil = this.querySelector('.gad-hsf__veil');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.gad-hsf__point');
        if (btn) {
          const spot = btn.closest('.gad-hsf__spot');
          spot.classList.contains('is-open') ? this.close() : this.open(spot);
          return;
        }
        if (e.target === this.veil) this.close();
      });
      this.onDocClick = (e) => {
        if (!this.contains(e.target)) this.close();
      };
      this.onKey = (e) => {
        if (e.key === 'Escape') this.close();
      };
      this.onScroll = () => this.place();
      this.addEventListener('shopify:block:select', (e) => {
        const spot = e.target.closest('.gad-hsf__spot');
        if (spot) this.open(spot);
      });
      this.addEventListener('shopify:block:deselect', () => this.close());
    }

    open(spot) {
      this.close();
      this.current = spot;
      spot.classList.add('is-open');
      spot.querySelector('.gad-hsf__point').setAttribute('aria-expanded', 'true');
      const pop = spot.querySelector('.gad-hsf__pop');
      pop.hidden = false;
      pop.classList.remove('gad-hsf__pop--left');
      if (window.matchMedia('(min-width: 750px)').matches && pop.getBoundingClientRect().right > window.innerWidth - 8) {
        pop.classList.add('gad-hsf__pop--left');
      }
      if (window.matchMedia('(max-width: 749px)').matches) this.veil.hidden = false;
      this.place();
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    place() {
      if (!this.current) return;
      const r = this.current.querySelector('.gad-hsf__point').getBoundingClientRect();
      this.current.querySelector('.gad-hsf__pop').style.setProperty('--gad-hsf-top', `${r.top + r.height / 2}px`);
      // El velo arranca en el borde de arriba de la sección: lo que está arriba no se oscurece.
      const top = this.closest('.shopify-section').getBoundingClientRect().top;
      this.veil.style.top = `${Math.max(0, top)}px`;
    }

    close() {
      if (!this.current) return;
      this.current.classList.remove('is-open');
      this.current.querySelector('.gad-hsf__point').setAttribute('aria-expanded', 'false');
      this.current.querySelector('.gad-hsf__pop').hidden = true;
      this.veil.hidden = true;
      this.current = null;
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('gad-hotspots-full')) customElements.define('gad-hotspots-full', GadHotspotsFull);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-merge"] && !Shopify.designMode) return;
  try {
    
  class GadMerge extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.merge(), { once: true });
      else this.merge();
    }

    merge() {
      if (!this.isConnected) return;
      this.moved = [];
      [this.dataset.a1, this.dataset.a2].forEach((id, i) => {
        const target = id && document.getElementById(id);
        const sec = target && target.closest('.shopify-section');
        const slot = this.querySelector(`[data-gad-merge-slot="${i + 1}"]`);
        if (!sec || sec.contains(this) || !slot) return;
        const mark = document.createComment('gad-merge');
        sec.before(mark);
        slot.appendChild(sec);
        this.moved.push([sec, mark]);
      });
      const note = this.querySelector('.gad-merge__note');
      if (note) note.hidden = this.moved.length === 2;
    }

    disconnectedCallback() {
      (this.moved || []).forEach(([sec, mark]) => {
        if (mark.parentNode) mark.replaceWith(sec);
      });
      this.moved = [];
    }
  }

  if (!customElements.get('gad-merge')) customElements.define('gad-merge', GadMerge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-parallax-hero"] && !Shopify.designMode) return;
  try {
    
  class GadParallax extends HTMLElement {
    connectedCallback() {
      if (this._ready || !window.matchMedia('(hover: hover)').matches) return;
      this._ready = true;
      this.layers = Array.from(this.querySelectorAll('.gad-px__layer'));
      this.k = parseFloat(this.dataset.intensity) || 20;
      this.addEventListener('pointermove', (e) => {
        if (window.Gadsden && Gadsden.reduceMotion()) return;
        const r = this.getBoundingClientRect();
        const nx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        const ny = ((e.clientY - r.top) / r.height - 0.5) * 2;
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.move(nx, ny));
      });
      this.addEventListener('pointerleave', () => this.move(0, 0));
    }

    move(nx, ny) {
      this.layers.forEach((el) => {
        const d = (parseFloat(el.dataset.depth) || 0) / 10;
        el.style.transform = `translate3d(${(-nx * d * this.k).toFixed(1)}px, ${(-ny * d * this.k).toFixed(1)}px, 0)`;
      });
    }
  }

  if (!customElements.get('gad-parallax')) customElements.define('gad-parallax', GadParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-results"] && !Shopify.designMode) return;
  try {
    
  class GadRing extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.target = parseFloat(this.dataset.value) || 0;
      this.num = this.querySelector('.gad-ring__num');
      if (window.Gadsden && (Gadsden.reduceMotion() || Gadsden.designMode)) return;
      this.style.setProperty('--p', 0);
      if (this.num) this.num.textContent = '0';
      this.io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.io.disconnect();
        this.animate();
      }, { rootMargin: '0px 0px -10% 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this._ready = false;
    }

    animate() {
      const duration = 1200;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        const value = this.target * eased;
        this.style.setProperty('--p', value);
        if (this.num) this.num.textContent = Math.round(value);
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('gad-ring')) customElements.define('gad-ring', GadRing);

  /* Dato libre (S10): si tiene un número, cuenta desde cero conservando lo que lo rodea. */
  class GadCount extends HTMLElement {
    connectedCallback() {
      if (this._ready || (window.Gadsden && (Gadsden.reduceMotion() || Gadsden.designMode))) return;
      this._ready = true;
      const text = this.textContent.trim();
      const m = text.match(/\d[\d.,]*/);
      if (!m) return;
      const raw = m[0];
      const sep = /[.,]\d{3}(\D|$)/.test(raw) ? raw.match(/[.,]/)[0] : '';
      const target = parseInt(raw.replace(/[.,]/g, ''), 10);
      if (!target) return;
      const fmt = (n) => (sep ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep) : String(n));
      const paint = (n) => (this.textContent = text.replace(raw, fmt(n)));
      paint(0);
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - start) / 1200);
          paint(Math.round(target * (1 - Math.pow(1 - t, 3))));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
      io.observe(this);
    }
  }

  if (!customElements.get('gad-count')) customElements.define('gad-count', GadCount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-shoppable"] && !Shopify.designMode) return;
  try {
    
  class GadShoppable extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.onDoc = (e) => {
        this.querySelectorAll('details[open]').forEach((d) => {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      };
      this.onKey = (e) => {
        if (e.key === 'Escape') this.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
      };
      document.addEventListener('click', this.onDoc);
      document.addEventListener('keydown', this.onKey);
      this.addEventListener('shopify:block:select', (e) => e.target.setAttribute('open', ''));
      this.addEventListener('shopify:block:deselect', (e) => e.target.removeAttribute('open'));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDoc);
      document.removeEventListener('keydown', this.onKey);
      this._ready = false;
    }
  }

  if (!customElements.get('gad-shoppable')) customElements.define('gad-shoppable', GadShoppable);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-ticker"] && !Shopify.designMode) return;
  try {
    
  class GadTicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('.gad-ticker__track');
      this.group = this.querySelector('.gad-ticker__group');
      if (!this.track || !this.group) return;
      this.base = Array.from(this.group.children);
      if (!this.base.length) return;
      this.speed = parseFloat(this.dataset.speed) || 2;
      this.addEventListener('touchstart', () => this.classList.contains('gad-ticker--pause') && this.classList.add('is-paused'), { passive: true });
      this.addEventListener('touchend', () => this.classList.remove('is-paused'));
      this.addEventListener('shopify:block:select', () => this.classList.add('is-paused'));
      this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));
      this.ro = new ResizeObserver(() => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.build());
      });
      this.ro.observe(this);
      this.build();
      this.track.addEventListener(
        'load',
        () => {
          this._built = false;
          this.build();
        },
        true
      );
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      this._ready = false;
    }

    build() {
      const vertical = this.classList.contains('gad-ticker--vertical');
      const width = vertical ? this.clientHeight : this.clientWidth;
      if (!width) return;
      if (this._lastWidth === width && this._built) return;
      this._lastWidth = width;
      this.track.querySelectorAll('[data-ticker-clone]').forEach((el) => el.remove());
      this.base.forEach((el) => this.group.appendChild(el));
      if (window.Gadsden && Gadsden.reduceMotion()) {
        this.classList.remove('is-running');
        this._built = true;
        return;
      }
      const measure = () => (vertical ? this.group.scrollHeight : this.group.scrollWidth);
      let unitWidth = measure();
      let guard = 0;
      while (unitWidth > 0 && unitWidth < width && guard < 30) {
        this.base.forEach((el) => this.group.appendChild(this.cloneItem(el)));
        unitWidth = measure();
        guard++;
      }
      const copy = this.group.cloneNode(true);
      copy.setAttribute('data-ticker-clone', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      copy.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      this.track.appendChild(copy);
      const pxPerSecond = this.speed * 30;
      this.style.setProperty('--dur', `${Math.max(4, unitWidth / pxPerSecond)}s`);
      this.classList.add('is-running');
      this._built = true;
    }

    cloneItem(el) {
      const clone = el.cloneNode(true);
      clone.setAttribute('data-ticker-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.inert = true;
      return clone;
    }
  }

  if (!customElements.get('gad-ticker')) customElements.define('gad-ticker', GadTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
